import z from "zod"

const IntegrationStatusSchema = z.object({
  bigblue: z.boolean(),
  klaviyo: z.boolean(),
  reveni: z.boolean(),
  loopReturns: z.boolean(),
  salesForce: z.boolean(),
  shopify: z.boolean(),
  whatsapp: z.boolean(),
  zendesk: z.boolean(),
  gorgias: z.boolean(),
  frontapp: z.boolean(),
  instagram: z.boolean(),
  messenger: z.boolean(),
  amphora: z.boolean(),
  rever: z.boolean(),
  gmail: z.boolean(),
  outlook: z.boolean(),
})

export const GetAllIntegrationsStatusResponseData = IntegrationStatusSchema.extend({
  enabled: IntegrationStatusSchema,
})
